import lineGraphMulti from './lineGraphMulti';

export default lineGraphMulti;
